import { useState, useEffect, useCallback } from 'react';

interface UseOfflineReturn {
    isOnline: boolean;
    wasOffline: boolean;
}

/**
 * Hook para detectar estado de conectividade
 */
export function useOffline(): UseOfflineReturn {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [wasOffline, setWasOffline] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            // Se estava offline e voltou online
            if (!isOnline) {
                setWasOffline(true);
                // Reset após alguns segundos
                setTimeout(() => setWasOffline(false), 5000);
            }
        };

        const handleOffline = () => {
            setIsOnline(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, [isOnline]);

    return { isOnline, wasOffline };
}

export default useOffline;
